module.exports = __webpack_public_path__ + "img/10.bd46b5c8.png";